export default function Header({ header, subHeader }) {
  return (
    <div>
      <div className="text-2xl font-bold max-w-xl primary-color">{header}</div>
      <div className="text-xl max-w-xl  secondary-color">{subHeader}</div>
    </div>
  );
}
